import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCurrencyFormatter]'
})
export class CurrencyFormatterDirective {

  constructor(public ngControl: NgControl) { }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event);
  }

  @HostListener('keydown', ['$event'])
  keydownBackspace(event) {
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (
      allowedKeys.includes(event.key) ||
      (event.key === 'a' && event.ctrlKey === true) ||  // Ctrl+A
      (event.key === 'c' && event.ctrlKey === true) ||  // Ctrl+C
      (event.key === 'v' && event.ctrlKey === true) ||  // Ctrl+V
      (event.key === 'x' && event.ctrlKey === true)     // Ctrl+X
    ) {
      return;  // Allow these keypresses
    }

    // Prevent special characters and space (allow numbers only)
    const isNumber = (event.keyCode >= 48 && event.keyCode <= 57) ||   // Number keys 0-9
      (event.keyCode >= 96 && event.keyCode <= 105);    // Numpad keys 0-9

    if (!isNumber || event.shiftKey) {
      event.preventDefault();  // Prevent if not a number
    }
  }

  onInputChange(event) {
    if (event) {
      let newVal = event.toString();
      newVal = newVal.replace(/,/g, "");
      newVal = newVal.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.ngControl.valueAccessor.writeValue(newVal);
    }
  }

}
